module.exports = __webpack_public_path__ + "img/bookValue.bce76f8a.png";